import React from "react";
import {
  Checkbox,
  Collapse,
  Divider,
  Typography,
  Box,
  CardContent,
  Card,
  Stack,
  Button,
  CardHeader,
  FormGroup,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormLabel,
  CardActionArea,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import PaymentsIcon from "@mui/icons-material/Payments";
import { zhTW } from "date-fns/locale";
import { format } from "date-fns";
import ConfirmDialog from "../ConfirmDialog";
import getCoupons from "../../api/user/getCoupons";
import placeOrder from "../../api/order/placeOrderV2";
import { useNavigate } from "react-router-dom";
import {
  isInvoiceDestinationValid,
  normalizeInvoiceValue,
  formatLoveCodeLabel,
} from "../../invoiceUtils";

export default function ReservationStep3({ order }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [couponSelected, setCouponSelected] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [invoiceType, setInvoiceType] = useState("carrier");
  const [invoiceValue, setInvoiceValue] = useState("");
  const [loveCodeSelection, setLoveCodeSelection] = useState(
    () => order.invoiceLoveCodes?.[0] || "custom"
  );
  const [customLoveCode, setCustomLoveCode] = useState("");
  const invoiceInputValue =
    invoiceType === "carrier"
      ? invoiceValue
      : loveCodeSelection === "custom"
      ? customLoveCode
      : loveCodeSelection;
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const responseData = await getCoupons();
        if (responseData.code === "000") {
          if (responseData.coupons) {
            setCoupons(responseData.coupons);
          }
        } else {
          setCoupons([]);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchCoupons();
  }, []);
  const handleConfirmDialogClicked = () => {
    setConfirmDialog(false);
  };
  const handlePaymentClicked = () => {
    const total = calculateSubTotal();
    const invoiceRequired = Boolean(order.invoiceEnable) && total > 0;
    const normalizedInvoiceValue = normalizeInvoiceValue(
      invoiceType,
      invoiceInputValue
    );
    const invoiceValid = isInvoiceDestinationValid(
      invoiceType,
      normalizedInvoiceValue
    );
    if (invoiceRequired && !invoiceValid) {
      setDialogContent(
        invoiceType === "carrier"
          ? "請輸入有效的手機條碼載具。"
          : "請輸入 3 至 7 位數的愛心碼。"
      );
      setConfirmDialog(true);
      return;
    }
    const selectedCouponIds = coupons
      .filter((coupon) => coupon.Checked === true)
      .map((coupon) => coupon.Id);
    const newOrder = async () => {
      try {
        const responseData = await placeOrder(
          order.tableCode,
          order.startTime,
          order.priceIndex,
          selectedCouponIds,
          invoiceRequired
            ? { type: invoiceType, value: normalizedInvoiceValue }
            : undefined
        );

        if (responseData.code === "000" || responseData.code === "0001") {
          const orderId = responseData.order_id;
          if (responseData.url === "" && responseData.code === "0001") {
            navigate(`/app/order/orderResult/${orderId}`);
          } else {
            window.location.href = responseData.url;
          }

          //navigate(`/app/paymentSimulation/${orderId}`);
        } else {
          setDialogContent("網路錯誤或是座位被訂走，請重新再試。/n(1)");
          setConfirmDialog(true);
        }
      } catch (err) {
        setDialogContent(
          err.response?.data?.message ||
            "網路錯誤或是座位被訂走，請重新再試。"
        );
        setConfirmDialog(true);
        console.error(err);
      }
    };
    newOrder();
  };

  const generateCouponChecks = (coupons) => {
    const CouponComponents = [];
    const now = new Date();

    if (coupons) {
      coupons.forEach((coupon, index) => {
        if (
          coupon.IsValid &&
          now >= new Date(coupon.StartDate) &&
          now <= new Date(coupon.EndDate)
        ) {
          CouponComponents.push(
            <Card
              key={"card" + index}
              sx={{
                marginBottom: 1,
                border: 1,
                borderColor: "gray",
                bgcolor: "#f2f2f2",
              }}
              elevation={0}
            >
              <CardActionArea
                disabled={
                  coupon.Price > calculateSubTotal() ? !coupon.Checked : false
                }
                onClick={() => {
                  handleCouponCheckClick(!coupon.Checked, index);
                }}
              >
                <CardContent>
                  <Box position="relative">
                    <Stack direction={"row"} spacing={1}>
                      <Checkbox
                        key={"checkbox" + index}
                        color="warning"
                        name={String(index)}
                        checked={!!coupon.Checked}
                        disabled={
                          coupon.Price > calculateSubTotal()
                            ? !coupon.Checked
                            : false
                        }
                      />
                      <Box>
                        <Box>
                          {/* Rest of your coupon card content */}
                          <Typography fontSize={20} component="div">
                            {coupon.Name}
                          </Typography>
                          <Typography color="text.secondary">
                            可用次數: {coupon.UsageLimit}
                          </Typography>
                          <Typography color="text.secondary">
                            有效日期:{" "}
                            {new Date(coupon.StartDate).toLocaleDateString()} 到{" "}
                            {new Date(coupon.EndDate).toLocaleDateString()}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                    {coupon.Price > calculateSubTotal() && !coupon.Checked && (
                      <Box
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          zIndex: 1, // Adjust as needed
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "white",
                          fontSize: "20px",
                        }}
                      >
                        已達折扣上限
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        }
      });
    }

    return CouponComponents;
  };
  // This function will render the checked coupons in a list
  const renderSelectedCoupons = () => {
    return coupons
      .filter((coupon) => coupon?.Checked)
      .map((selectedCoupon, index) => (
        <Stack
          key={"couponStack" + index}
          paddingTop={1}
          direction="row"
          justifyContent="space-between"
        >
          <Typography key={"couponName" + index} variant="body2">
            {selectedCoupon.Name}
          </Typography>
          <Typography key={"couponPrice" + index} variant="body2">
            -${selectedCoupon.Price}
          </Typography>
        </Stack>
      ));
  };
  const handleCouponCheckClick = (checked, index) => {
    // Create a new copy of the coupons array
    const updatedCoupons = [...coupons];

    // Update the specific coupon in the new array
    if (updatedCoupons[index]) {
      updatedCoupons[index] = {
        ...updatedCoupons[index],
        Checked: checked,
      };
    }

    // Set the updated array as the new state
    setCoupons(updatedCoupons);
  };

  const handleCouponClick = () => {
    if (couponSelected === 1) {
      setCouponSelected(0); // close the item if it's already open
    } else {
      setCouponSelected(1);
    }
  };

  // Helper function to map day of the week to Chinese character
  const getDayInChinese = (date) => {
    const days = ["日", "一", "二", "三", "四", "五", "六"];
    const day = date.getDay();
    return days[day];
  };
  const formatDateToCustomString = (date) => {
    if (!(date instanceof Date)) {
      return "未選擇";
    }

    const monthDay = format(date, "MM/dd", { locale: zhTW });
    const chineseDay = getDayInChinese(date);
    const time = format(date, "HH:mm", { locale: zhTW });

    return `${monthDay}(${chineseDay}) ${time}`;
  };
  const calculateHours = (startTime, endTime) => {
    // Calculate the difference in minutes between start and end times.
    const differenceInMinutes = (endTime - startTime) / (1000 * 60);

    // Convert the duration into thirty-minute increments.
    const increments = differenceInMinutes / 60;
    return increments;
  };
  const calculateSubTotal = () => {
    // Start with the original order total
    let subtotal = order.total;

    // Deduct the value of each selected coupon from the subtotal
    coupons
      .filter((coupon) => coupon.Checked)
      .forEach((selectedCoupon) => {
        subtotal -= selectedCoupon.Price;
      });

    // Ensure subtotal doesn't go below zero
    return Math.max(0, subtotal);
  };

  const invoiceRequired =
    Boolean(order.invoiceEnable) && calculateSubTotal() > 0;
  const normalizedInvoiceValue = normalizeInvoiceValue(
    invoiceType,
    invoiceInputValue
  );
  const invoiceValid =
    !invoiceRequired ||
    isInvoiceDestinationValid(invoiceType, normalizedInvoiceValue);

  return (
    <>
      <Box paddingBottom={10}>
        <Card sx={{ margin: 1 }}>
          <CardContent>
            <Typography fontSize={"14pt"} fontWeight={"bold"}>
              訂位明細
            </Typography>
            <Divider orientation="horizontal" flexItem />
            <Stack direction="row">
              <Typography fontWeight={"bold"} fontSize={"14pt"}>
                {order.storeName}
              </Typography>
              <Typography
                fontWeight={"bold"}
                fontSize={"14pt"}
                color="text.primary"
              >
                {order.tableName}
              </Typography>
            </Stack>
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction="row"
              justifyItems="flex-start"
              alignItems="flex-start"
            >
              <Box flexGrow={1} width="max-content">
                <Stack direction={"row"}>
                  {" "}
                  <Typography align="left">開始　</Typography>
                  <Typography color={theme.palette.text.secondary} align="left">
                    {formatDateToCustomString(order.startTime)}
                  </Typography>
                </Stack>

                <Stack direction={"row"}>
                  {" "}
                  <Typography align="left">結束　</Typography>
                  <Typography color={theme.palette.text.secondary} align="left">
                    {formatDateToCustomString(order.endTime)}
                  </Typography>
                </Stack>
              </Box>

              <Stack
                direction="row"
                spacing={3}
                justifySelf={"flex-end"}
                alignSelf={"flex-end"}
              >
                <Typography color="text.secondary">
                  {calculateHours(order.startTime, order.endTime)}小時
                </Typography>
                <Typography color="text.secondary">${order.total}</Typography>
              </Stack>
            </Stack>
            <Divider orientation="horizontal" flexItem></Divider>
            {renderSelectedCoupons()}{" "}
            {/* Call the function to render selected coupons */}
            <Divider orientation="horizontal" flexItem></Divider>
            <Stack
              direction="row"
              marginTop={1}
              display={"flex"}
              alignItems={"flex-end"}
              justifyContent="space-between"
            >
              <Typography color="text.primary">小計</Typography>
              <Typography color="text.primary">
                ${calculateSubTotal()}
              </Typography>
            </Stack>
          </CardContent>
        </Card>
        {invoiceRequired && (
          <Card sx={{ margin: 1 }}>
            <CardContent>
              <Typography fontSize={"14pt"} fontWeight={"bold"}>
                電子發票
              </Typography>
              <RadioGroup
                row
                value={invoiceType}
                onChange={(event) => {
                  setInvoiceType(event.target.value);
                  setInvoiceValue("");
                  setLoveCodeSelection(order.invoiceLoveCodes?.[0] || "custom");
                  setCustomLoveCode("");
                }}
              >
                <FormControlLabel
                  value="carrier"
                  control={<Radio color="secondary" />}
                  label="手機條碼載具"
                />
                <FormControlLabel
                  value="love_code"
                  control={<Radio color="secondary" />}
                  label="捐贈發票"
                />
              </RadioGroup>
              {invoiceType === "carrier" ? (
                <TextField
                  fullWidth
                  color="secondary"
                  label="手機條碼載具"
                  placeholder="/ABC+123"
                  value={invoiceValue}
                  onChange={(event) => setInvoiceValue(event.target.value)}
                  error={invoiceValue.length > 0 && !invoiceValid}
                />
              ) : (
                <FormControl fullWidth>
                  <FormLabel id="love-code-options-label" color="secondary">
                    愛心碼
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="love-code-options-label"
                    value={loveCodeSelection}
                    onChange={(event) => setLoveCodeSelection(event.target.value)}
                  >
                    {(order.invoiceLoveCodes || []).map((code) => (
                      <FormControlLabel
                        key={code}
                        value={code}
                        control={<Radio color="secondary" />}
                        label={formatLoveCodeLabel(code, order.invoiceLoveCodeNames)}
                        sx={{ "& .MuiFormControlLabel-label": { overflowWrap: "anywhere" } }}
                      />
                    ))}
                    <FormControlLabel
                      value="custom"
                      control={<Radio color="secondary" />}
                      label="自行輸入"
                    />
                  </RadioGroup>
                  <TextField
                    fullWidth
                    color="secondary"
                    label="自行輸入愛心碼"
                    value={customLoveCode}
                    disabled={loveCodeSelection !== "custom"}
                    inputProps={{ inputMode: "numeric" }}
                    onChange={(event) => setCustomLoveCode(event.target.value)}
                    error={
                      loveCodeSelection === "custom" &&
                      customLoveCode.length > 0 &&
                      !invoiceValid
                    }
                    helperText="請輸入 3 至 7 位數的愛心碼"
                  />
                </FormControl>
              )}
            </CardContent>
          </Card>
        )}
        <Card sx={{ margin: 1 }}>
          <CardActionArea onClick={() => handleCouponClick()}>
            <CardContent>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography fontSize={"14pt"} fontWeight={"bold"}>
                  優惠券
                </Typography>
                {couponSelected === 1 ? <ExpandLess /> : <ExpandMore />}
              </Stack>
            </CardContent>
          </CardActionArea>
          <Collapse in={couponSelected === 1} timeout="auto" unmountOnExit>
            <FormGroup sx={{ m: "10px" }}>
              {couponSelected === 1 && coupons
                ? generateCouponChecks(coupons)
                : generateCouponChecks([])}
            </FormGroup>
          </Collapse>
        </Card>
        <Box
          borderTop={1}
          borderColor={"#ababab"}
          borderRadius={2}
          justifySelf={"flex-end"}
          zIndex={3}
          sx={{
            display: "flex",
            bgcolor: theme.palette.primary.main,
            width: "100%",
            height: "120px",
            position: "fixed", // add this
            bottom: 0, // and this
          }}
        >
          <Divider orientation="vertical"></Divider>

          <Box
            width="100%"
            flexDirection={"column"}
            display={"flex"}
            justifyContent={"center"}
          >
            <Typography
              align="center"
              style={{
                color: theme.palette.text.primary,
                fontWeight: "bold",
                fontSize: "14pt",
              }}
            >
              總計 ${calculateSubTotal()}
            </Typography>
            <Button
              variant="contained"
              onClick={handlePaymentClicked}
              disabled={!invoiceValid}
              sx={{
                fontSize: "14pt",
                height: "56px",
                marginX: "15px",
                marginBottom: "28px",
                background: theme.gradients.primary,
                color: theme.palette.text.selected,
                border: theme.gradients.primary,
                borderRadius: "10px",
                "&.Mui-disabled": {
                  background: theme.palette.action.disabledBackground,
                  color: theme.palette.action.disabled, // Customize this color as needed
                },
              }}
            >
              付款
            </Button>
          </Box>
        </Box>
      </Box>
      <ConfirmDialog
        open={confirmDialog}
        content={dialogContent}
        confirmOnly={true}
        onClose={handleConfirmDialogClicked}
      ></ConfirmDialog>
    </>
  );
}
